export default "__VITE_ASSET__DnyY9yV9__"